import { useEffect, useState } from 'react';

import type { BrandOwner } from 'src/App/generated/graphql-types';
import { getSeekId } from 'src/utils/account-selection';

import { useWithEmailVerify } from './WithEmailVerify/withEmailVerify';

export const useWithOwner = (): BrandOwner | undefined => {
  const { ownerType: type } = useWithEmailVerify();
  const [id, setId] = useState<string>();

  useEffect(() => {
    setId(getSeekId());
  }, []);

  if (id && type) {
    return {
      id,
      type,
    };
  }

  return;
};
